import { render, staticRenderFns } from "./U_DataBusiness.vue?vue&type=template&id=4c28d169&scoped=true&"
import script from "./U_DataBusiness.vue?vue&type=script&lang=js&"
export * from "./U_DataBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28d169",
  null
  
)

export default component.exports